import heroBackground from '@/assets/images/hero_bg.png'
import Button from '@/shared/components/Button'
import OffsetFrame from '@/shared/components/OffsetFrame'

import './HomeHero.css'

export default function HomeHero() {
  return (
    <section className="home-hero relative min-h-[660px] overflow-hidden bg-sky-300 min-[900px]:min-h-[670px]">
      <img
        src={heroBackground}
        alt="Modern Caribbean home beside a pool"
        className="home-hero__background absolute inset-0 h-full w-full object-cover"
      />
      <div className="relative z-10 flex min-h-[660px] items-center px-[5%] min-[900px]:min-h-[670px] min-[900px]:translate-y-[2px] min-[900px]:px-[7.5%]">
        <OffsetFrame variant="hero" className="home-hero__panel box-border w-full max-w-[387px] pb-[31px] pl-[16px] pr-[16px] pt-[14px] min-[900px]:h-[364px]">
          <p className="home-hero__eyebrow">TECMA</p>
          <h1 className="home-hero__title -mt-[1px]">FLAT ROOF<br />SYSTEM</h1>
          <p className="home-hero__description mt-[12px] max-w-sm">ROOFING SYSTEM BUILT FOR<br />THE CARIBBEAN.</p>
          <div className="home-hero__action ml-[9px] mt-[39px]">
            <Button size="hero" aria-label="Explore our products">Explore Our Products</Button>
          </div>
        </OffsetFrame>
      </div>
      <div aria-hidden="true" className="home-hero__corner home-hero__corner--navy absolute bottom-0 right-0 h-24 w-24 rotate-45 translate-x-10 translate-y-10" />
      <div aria-hidden="true" className="home-hero__corner home-hero__corner--red absolute bottom-0 right-2 h-20 w-20 rotate-45 translate-x-9 translate-y-9" />
    </section>
  )
}
